export interface SupportedLanguage {
  display: string;
  value: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
  {display: 'English', value: 'en', flag: 'gb'},
  {display: 'Lietuvių', value: 'lt', flag: 'lt'},
  {display: 'Deutsche', value: 'de', flag: 'de'},
  {display: 'Pусский', value: 'ru', flag: 'ru'},
  {display: 'Polski', value: 'pl', flag: 'pl'},
  {display: 'Français', value: 'fr', flag: 'fr'},
  {display: 'Latviski', value: 'lv', flag: 'lv'},
  {display: 'Italiano', value: 'it', flag: 'it'},
  {display: 'Český', value: 'cz', flag: 'cz'},
  {display: 'Română', value: 'ro', flag: 'ro'},
  {display: 'Español', value: 'es', flag: 'es'},
  {display: 'Український', value: 'uk', flag: 'ua'},
  {display: 'Magyar', value: 'hu', flag: 'hu'},
  {display: 'Български', value: 'bg', flag: 'bg'},
  {display: 'Slovenčina', value: 'sk', flag: 'sk'},
  {display: 'Português', value: 'pt', flag: 'pt'},
  {display: 'Hrvatski', value: 'hr', flag: 'hr'},
  {display: 'Türkçe', value: 'tr', flag: 'tr'},
  {display: 'Nederlands', value: 'nl', flag: 'nl'},
  {display: 'Српски', value: 'sr', flag: 'rs'},
  {display: 'Slovenščina', value: 'sl', flag: 'si'},
];
